#### `self` query

We’ve added a [`self` query] to return information about an access token’s organizations.

This can be a convenient alternative to the [`hiringOrganization` query] when working with [browser tokens].
Instead of needing to specify the hirer ID explicitly, it returns the SEEK hirer the browser token is scoped to.

```graphql label="Query" hirerId="seekAnzPublicTest:organization:seek:93WyyF1h" scope="query:organizations"
query {
  self {
    hirer {
      id {
        value
      }
      name
      seekApiCapabilities {
        relationshipTypeCodes
        applicationMethodCodes
      }
    }
  }
}
```

```json label="Result"
{
  "self": {
    "hirer": {
      "id": {
        "value": "seekAnzPublicTest:organization:seek:93WyyF1h"
      },
      "name": "Acme Corp",
      "seekApiCapabilities": {
        "relationshipTypeCodes": [
          "ApplicationExport",
          "ApplicationPrefill",
          "CandidateProfiles",
          "CandidateVerification",
          "JobPosting",
          "ProactiveSourcing"
        ],
        "applicationMethodCodes": ["ApplicationUri"]
      }
    }
  }
}
```

[`hiringorganization` query]: /schema/query/hiringOrganization
[`self` query]: /schema/query/self
[browser tokens]: /auth/browser-tokens
